<template>
  <div id="oath-reg2">
    <h2 class="title-dash">{{ $t('dss.page.security.oathAdd.title') }}</h2>
    <stihl-section>

      <div class="form-text mt-4 info-grp" v-html="$t('dss.page.security.oathAdd.appInfo', [
            `<a class=link target=_blank rel='noopener noreferrer'
              href=https://www.microsoft.com/en-us/security/mobile-authenticator-app>Microsoft Authenticator</a>`,
            `<a class=link target=_blank rel='noopener noreferrer' href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'>Google Authenticator</a>`,
            `<a class=link target=_blank rel='noopener noreferrer' href='https://authy.com/download/'>Authy</a>`,
          ])"></div>

      <div class="form-group mt-4 qr-grp">
        <label class="form-label">{{ $t('dss.page.security.oathAdd.headScan') }}</label>
        <QRCodeVue3 :value="otpAuth" :width="300" :height="300"
                    :dots-options="{type: 'square'}" myclass="qrcode"
                    :image-options="{hideBackgroundDots:true,imageSize:.25,margin:0}"
                    image="data:image/svg+xml;base64,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"
                    :corners-square-options="true"/>
        <div class="form-text" v-html="$t('dss.page.security.oathAdd.infoScanBottom', [
                `<a id=oathKey class='link' data-bs-container='body' data-bs-toggle=popover data-bs-placement=top
                    data-bs-title='${$t('dss.page.security.oathAdd.infoKeyTitle')}'
                    data-bs-content='${oathSecret}'>
                    ${$t('dss.page.security.oathAdd.infoKey')}</a>`
            ])"></div>
      </div>

      <form @submit.prevent="">
        <group-input id="code"
                     :label="$t('dss.page.security.oathAdd.headVerify')"
                     class="form-group mt-4 input-grp"
                     autocomplete="off" placeholder="XXXXXX" autofocus
                     inputmode="numeric" pattern="[0-9]{6}"
                     v-model="v$.code.$model"
                     :validation-errors="v$.code.$errors"
                     @keyup.enter.stop="verify">
          <template v-slot:after>
            <div class="form-text">{{ $t('dss.page.security.oathAdd.infoVerify') }}</div>
          </template>
        </group-input>

        <div class="mt-4 buttons">
          <input id="verify" type="button" class="btn btn-primary" :value="$t('dss.button.verify')" @click="verify">
        </div>
      </form>

    </stihl-section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import StihlSection from '@/components/ui/StihlSection.vue';
import GroupInput from '@/components/ui/GroupInput.vue';
import useVuelidate from '@vuelidate/core';
import { required, validOTP } from '@/components/validators';
import ForgerockTemplate from '@/components/layout/ForgerockTemplate.vue';
import StihlOverlay from '@/components/ui/StihlOverlay.vue';
import HelpMenu from '@/components/ui/HelpMenu.vue';
import QRCodeVue3 from 'qrcode-vue3';
import { initPopovers } from '@/components/bootstrap-utils';
import * as OTPAuth from 'otpauth';
import { helpers } from '@vuelidate/validators';

export default defineComponent({
  name: 'OathRegistrationVerifier',
  components: { HelpMenu, ForgerockTemplate, StihlSection, GroupInput, StihlOverlay, QRCodeVue3 },
  emits: ['verify:code'],
  props: {
    otpAuth: { type: String, required: true },
  },
  data: () => ({
    code: '',
  }),

  computed: {
    oathSecret(): string {
      return OTPAuth.URI.parse(this.otpAuth).secret.base32;
    },
  },

  methods: {
    verify() {
      (this.v$ as any).code.$touch(); // trigger validation
      if (this.v$.$invalid) return console.error('validation failed', this.v$.$errors);

      this.$emit('verify:code', this.code);
      this.code = ''; // clear input
    }
  },

  mounted() {
    initPopovers();
  },

  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      code: { required: helpers.withMessage(this.$t('dss.validations.validOTP'), required), validOTP },
    };
  },
});
</script>
<style>
</style>
